import React, { Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import ModuleLoaderLazy from '../redux/ModuleLoaderLazy';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
/**
 * This is the global init for amsterdamn, this we trigger auth, fetching
 * of counts, and listening for damz activity events.
 */ export const DamzGlobalLoadable = (props)=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "DamzGlobalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, null)
    }, /*#__PURE__*/ React.createElement(ModuleLoaderLazy, null)));
};
DamzGlobalLoadable.displayName = 'DamzGlobalLoadable';
export default DamzGlobalLoadable;

//# sourceMappingURL=DamzGlobalLoadable.js.map